import React, { useState, useEffect, useRef } from "react";
import "./Services.css";
import kids1 from "../assets/kids1.jpg";
import kids2 from "../assets/kids2.jpg";
import kids4 from "../assets/kids4.jpg";
import metric1 from "../assets/metric1.jpg";
import family1 from "../assets/family1.jpg";

/*
  Services component: a swipable card that contains an image slideshow
  for each service, plus title, description and a CTA button.
*/
const Services = () => {
  // --- Data: list of services (replace image paths with your assets)
  const services = [
    {
      title: "Matric Dance Photoshoot",
      description: "This is an exciting time as you reach a significant milestone in your life. We capture your day as you celebrate with your partner and family.  Our coverage starts from home while dressing up until you arrive at the venue You will get 20 edited images, combination of color and B&W Duration 1,5 hours",
      images: [kids1, metric1, family1],
      link: "https://wa.me/27828179265?text=Hi%2C%20tell%20me%20about%20Matric%20Dance%20Photoshoot❤️."
    },
    {
      title: "Cake Smah Photoshoot",
      description: "A cake smash session is a wonderful way to celebrate your baby’s first birthday and create precious memories to last a lifetime. The baby get to taste the cake for the first time. The session is maximum 1 hour as the baby might get tired quickly",
      images: [kids2, metric1, family1],
      link: "https://wa.me/27828179265?text=Hi%2C%20tell%20me%20about%20Cakeo%20Smash%20Photoshoot❤️."
    },
    {
      title: "Maternity Photoshoot",
      description: "A maternity session is a wonderful way for mommy to bond with her precious bundle of joy. This session allows you to look back at the moments of your pregnancy journey. The session is maximum 1 hour. You are welcome to bring the siblings. The session takes place indoors or at the location of your choice. Mommy must come dress up in a  comfortable outfit of their choice that will show the bump. Mommy must be comfortable and not be shy to pose with the growing bump. Preferably around 7 months, the idea is for mommy & daddy to bond with the baby.  Please take note, make up is highly recommended for pictures. You will get 20 – 30 edited pictures, combination of colour and B&W pictures",
      images: [kids4, metric1, family1],
      link: "https://wa.me/27828179265?text=Hi%2C%20tell%20me%20about%20Maternity%20Sessions"
    }
  ];

  // --- State: which service card is active
  const [currentService, setCurrentService] = useState(0);

  // --- State: which image inside the active service is showing
  const [currentImage, setCurrentImage] = useState(0);

  // --- Refs for touch/swipe handling
  const touchStartX = useRef(null);
  const touchEndX = useRef(null);

  // --- Auto-advance images inside the active service
  useEffect(() => {
    // set up interval to change image every 3 seconds
    const interval = setInterval(() => {
      setCurrentImage((prev) => {
        const count = services[currentService].images.length;
        return (prev + 1) % count;
      });
    }, 3000);

    // cleanup on unmount or when currentService changes
    return () => clearInterval(interval);
  }, [currentService, services]);

  // --- Move to next service card
  const nextService = () => {
    setCurrentService((prev) => (prev + 1) % services.length);
    setCurrentImage(0); // reset image index when service changes
  };

  // --- Move to previous service card
  const prevService = () => {
    setCurrentService((prev) => (prev === 0 ? services.length - 1 : prev - 1));
    setCurrentImage(0);
  };

  // --- Touch handlers for mobile swipe
  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    if (touchStartX.current === null || touchEndX.current === null) return;
    const delta = touchStartX.current - touchEndX.current;
    const threshold = 50; // minimum px to consider a swipe
    if (delta > threshold) {
      // swiped left -> next
      nextService();
    } else if (delta < -threshold) {
      // swiped right -> prev
      prevService();
    }
    // reset refs
    touchStartX.current = null;
    touchEndX.current = null;
  };

  return (
    <section id="services" className="services">
      <h2 className="services-heading">Our Services</h2>
      <p className="services-description">
        We offer photography services such as studio, maternity, newborns, outdoor, matric dance, engagements , all events (weddings, kiddies & adults parties, cooperate, school etc.) We also offer personalized designs such as mugs, calendars, canvas, mouse pads, fridge magnets, watches, key rings, coasters etc. We strive to be unique and creative in order turn your imagination into reality. We capture high quality digital images with passion, patience and love. We strive to be professional and punctual at all times.
      </p>

      <div className="services-prompt-box">
        <p className="services-prompt">
          See our services below:
        </p>
      </div>
      <div
        className="service-card"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {/* Image slideshow inside the card */}
        <div className="service-image-wrap">
          <img
            src={services[currentService].images[currentImage]}
            alt={services[currentService].title}
            className="service-image"
          />
        </div>

        {/* Text content */}
        <div className="service-body">
          <h3 className="service-title">{services[currentService].title}</h3>
          <p className="service-desc">{services[currentService].description}</p>
          <a
            href={services[currentService].link}
            className="service-cta"
            target="_blank"
            rel="noopener noreferrer"
          >
            Book Now
          </a>
        </div>
      </div>

      {/* Controls: previous / next */}
      <div className="service-controls">
        <button onClick={prevService} className="service-nav">‹ Prev</button>
        <div className="service-dots">
          {services.map((s, i) => (
            <button
              key={i}
              className={`dot ${i === currentService ? "active" : ""}`}
              onClick={() => { setCurrentService(i); setCurrentImage(0); }}
              aria-label={`Show service ${i + 1}`}
            />
          ))}
        </div>
        <button onClick={nextService} className="service-nav">Next ›</button>
      </div>
    </section>
  );
};

export default Services;
